import Vue from 'vue'
import App from './App.vue'
import router from './router'

require('./assets/fonts/typekit.css')
require('./assets/fonts/fonts.css')
require('./assets/css/all.min.css')
require('./assets/css/layout.css')
require('./assets/css/responsive.css')

Vue.config.productionTip = false;

Vue.prototype.$mirzacles = require('./utils/mirzacles').default;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
